import DrawerButton from "components/form/DrawerButton";
import Error from "components/form/Error";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import useTopSellingSubmit from "hooks/useTopSellingSubmit";
import SelectStateSingle from "components/form/SelectStateSingle";
import SelectPackage from "components/form/SelectPackage";
import InputArea from "components/form/InputArea";
import InputAreaSmall from "components/form/InputAreaSmall";
import React, { useState } from "react";
import Scrollbars from "react-custom-scrollbars-2";

// import UploaderSlider from "components/image-uploader/UploaderSlider";
// import { FiX } from "react-icons/fi";

const TopSellingDrawer = ({ id }) => {
  const [carUrl, setCarUrl] = useState("");
  const {
    register,
    handleSubmit,
    selectedCity,
    onSubmit,
    handleCityChange,
    trigger,
    errors,
    noOfNights,
    setNoOfDays,
    noOfDays,
    setSelectedCity,
    setNoOfNights,
    // existingImage,
    // setExistingImage,
    setPackageCode,
    packagecode,
    setPackageId,
    route,
    setRoute,
    loading,
  } = useTopSellingSubmit(id, carUrl, setCarUrl);
  // const handleCancelImage = () => {
  //   setCarUrl("");
  //   setExistingImage("");
  // };
  // useEffect(() => {
  //   if (id && existingImage) {
  //     setCarUrl(existingImage);
  //   } else {
  //     setCarUrl("");
  //   }
  // }, [id, existingImage]);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title title={"Edit Package"} description={""} />
        ) : (
          <Title title={"Add Package"} description={""} />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-8 flex-grow scrollbar-hide w-full max-h-full pb-40">
            <div className="grid grid-cols-8 gap-5 mb-3">
              {/* <div className="col-span-8">
                <LabelArea label={"Image"} />
                {carUrl ? (
                  <div className="flex items-center">
                    <img
                      style={{
                        objectFit: "cover",
                        borderRadius: "10px",
                        width: "350px",
                        height: "200px",
                      }}
                      src={process.env.REACT_APP_API_IMAGE_URL + carUrl}
                      alt="caricon"
                    />

                    <FiX
                      size={20}
                      className="cursor-pointer"
                      onClick={() => handleCancelImage("pan")}
                    />
                  </div>
                ) : (
                  <UploaderSlider
                    is_multiple={true}
                    folder="slider"
                    name_merge="Package"
                    imageUrl={carUrl}
                    setImageUrl={setCarUrl}
                    no_of_image={1}
                  />
                )}
                <Error errorName={errors.image} />
              </div> */}

              <div className="col-span-4">
                <LabelArea label={"Package Code"} />
                <SelectPackage
                  register={register}
                  label="Package Code"
                  name="package_code"
                  selectedVehicle={packagecode}
                  onChange={(e) => setPackageCode(e)}
                  setNoOfNights={setNoOfNights}
                  setNoOfDays={setNoOfDays}
                  setStateName={setSelectedCity}
                  setPackageCode={setPackageCode}
                  setPackageId={setPackageId}
                  setRoute={setRoute}
                  type="text"
                  placeholder={"--Choose--"}
                />
                <Error errorName={errors.package_code} />
              </div>

              <div className="col-span-4">
                <LabelArea label={"Route"} />
                <InputArea
                  trigger={trigger}
                  register={register}
                  label="Route"
                  name="route"
                  type="text"
                  readOnly={true}
                  value={route}
                  placeholder={"Route"}
                  maxLength={120}
                  required={false}
                />
                <Error errorName={errors.route} />
              </div>

              <div className="col-span-4">
                <LabelArea label={"No. of Nights"} />
                <InputAreaSmall
                  trigger={trigger}
                  register={register}
                  label="No. of Nights"
                  name="nights"
                  type="number"
                  readOnly={true}
                  value={noOfNights}
                  placeholder={"Night"}
                  maxLength={2}
                  onChangeFunction={(e) => {
                    setNoOfNights(e.target.value);
                    setNoOfDays(Number(e.target.value) + 1);
                  }}
                />
                <Error errorName={errors.nights} />
              </div>

              <div className="col-span-4">
                <LabelArea label={"No. of Days"} />
                <InputAreaSmall
                  trigger={trigger}
                  register={register}
                  label="No. of Days"
                  name="days"
                  readOnly={true}
                  type="number"
                  value={noOfDays}
                  placeholder={"Days"}
                  maxLength={2}
                />
                <Error errorName={errors.days} />
              </div>

              <div className="col-span-4">
                <LabelArea label={"State"} />
                <SelectStateSingle
                  register={register}
                  label="State"
                  name="state"
                  selectedState={selectedCity}
                  handleStateChange={handleCityChange}
                  readOnly={true}
                  selectedCountryId={110}
                />
                <Error errorName={errors.state} />
              </div>
            </div>
          </div>

          <DrawerButton
            isSubmitting={loading}
            id={id}
            title={id ? "Update" : "Submit"}
          />
        </form>
      </Scrollbars>
    </>
  );
};

export default TopSellingDrawer;
